import { createSlice } from "@reduxjs/toolkit";
import * as MAP_CONSTANTS from "../common/constants/MapOptions";

const initialState = {
    mapView: MAP_CONSTANTS.MAP_VIEWS[0],
    mapStyle: MAP_CONSTANTS.MAP_STYLES[0],
    geodataOption: MAP_CONSTANTS.GEODATA_OPTIONS[0],
    
};

const layersSlice = createSlice({
    name: 'layersSlice',
    initialState,
    reducers: {
        updateMapStyle: (state, action) => {
            state.mapStyle = action.payload;
        },
        updateGeodataOption: (state, action) => {
            state.geodataOption = action.payload;
        },
    },
});

export default layersSlice.reducer;

export const {
    updateMapStyle,
    updateGeodataOption,
} = layersSlice.actions;